export default __webpack_public_path__ + "static/media/pinklemonade.5959cd57.jpeg";